const basicConfig = {
  contentDialogBoxIsSetting: false,
  typeAssetExport: "none",
  proxyUrl: "https://cors-anywhere.herokuapp.com/",
}
export default basicConfig
